export const formatInterventionDate = (value) => value ? new Intl.DateTimeFormat('fr-FR').format(new Date(value)) : '—';
export const formatInterventionAmount = (value) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Number(value) || 0);
